import(/* webpackMode: "eager" */ "/app/apps/ashtrom-properties/app/[locale]/not-found.tsx");
